import React from 'react';

// Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { CTA } from '../../@types/cta';
import SmallBanner from '../../components/smallBanner';

// Components

interface SmallBannerSectionProps extends Section {
  backgroundImage?: {
    backgroundImage: ImageType;
    backgroundMobileImage: ImageType;
  };
  text: {
    text: string;
  };
  cta: CTA;
}

const SmallBannerSection: SectionComponent<SmallBannerSectionProps> = React.memo(
  ({ backgroundImage, cta, text }) => (
    <>
      <SmallBanner
        backgroundImage={backgroundImage?.backgroundImage}
        backgroundMobileImage={backgroundImage?.backgroundMobileImage}
        cta={cta}
        text={text.text}
      />
    </>
  ),
);

export default SmallBannerSection;
